// Mock data for FutureBuildX website

export const services = [
  {
    id: 1,
    title: "AI, Robotics & IoT Workshops",
    description: "Hands-on training programs for school and college students to learn cutting-edge technology through practical projects.",
    icon: "cpu",
    features: ["Practical Learning", "Industry Projects", "Certification", "Expert Mentors"]
  },
  {
    id: 2,
    title: "3D Printing Services",
    description: "Professional prototype and model development services for students and educational projects.",
    icon: "box",
    features: ["Rapid Prototyping", "Custom Models", "Educational Discounts", "Design Support"]
  },
  {
    id: 3,
    title: "PCB Designing",
    description: "Custom circuit board design and development services for academic and innovation projects.",
    icon: "circuit-board",
    features: ["Custom Design", "Testing Support", "Documentation", "Fast Turnaround"]
  },
  {
    id: 4,
    title: "College Project Guidance",
    description: "Complete guidance and documentation support for college engineering projects from ideation to completion.",
    icon: "graduation-cap",
    features: ["End-to-End Support", "Documentation", "Presentation Training", "Technical Review"]
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Practical Learning",
    description: "Hands-on experience with real-world projects and cutting-edge technology.",
    icon: "lightbulb"
  },
  {
    id: 2,
    title: "Industry-Oriented Skills",
    description: "Learn skills that are directly applicable in the tech industry.",
    icon: "briefcase"
  },
  {
    id: 3,
    title: "Expert Guidance",
    description: "Learn from experienced professionals and industry experts.",
    icon: "users"
  },
  {
    id: 4,
    title: "Innovation Focus",
    description: "Foster creativity and innovation through project-based learning.",
    icon: "rocket"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Mera Pandey",
    role: "Principal",
    institution: "Horizon Academy",
    content: "Our students were thrilled with the AI workshop. The hands-on approach makes all the difference.",
    rating: 5
  }
];

export const galleryImages = [
  { 
    id: 1, 
    title: "AI & Robotics Workshop - Session 1", 
    category: "workshop",
    image: "/workshop-1.jpeg",
    description: "Students learning about AI and robotics fundamentals"
  },
  { 
    id: 2, 
    title: "AI & Robotics Workshop - Session 2", 
    category: "workshop",
    image: "/workshop-2.jpeg",
    description: "Interactive robotics training session with students"
  },
  { 
    id: 3, 
    title: "AI & Robotics Workshop - Session 3", 
    category: "workshop",
    image: "/workshop-3.jpeg",
    description: "Hands-on AI learning experience for students"
  },
  { 
    id: 4, 
    title: "Humanoid Robot V3", 
    category: "projects",
    image: "/humanoid-robot-v3.jpeg",
    description: "Advanced humanoid robot with LED eyes and articulated limbs"
  },
  { 
    id: 5, 
    title: "Bluetooth Controlled Car", 
    category: "projects",
    image: "/bluetooth-car.jpeg",
    description: "Student project - Bluetooth controlled robotic car with motor drivers"
  },
  { 
    id: 6, 
    title: "Fire Extinguisher Robot", 
    category: "projects",
    image: "/fire-extinguisher-robot.jpeg",
    description: "Innovative fire extinguisher robot with Arduino control and sensors"
  },
  { 
    id: 7, 
    title: "Obstacle Avoidance Robot", 
    category: "projects",
    image: "/obstacle-avoidance-robot.jpeg",
    description: "Smart obstacle avoidance robot with ultrasonic sensors"
  },
  { 
    id: 8, 
    title: "3D Printed Prototype", 
    category: "3d-printing",
    image: "/3d-print-1.jpeg",
    description: "Custom 3D printed prototype model"
  },
  { 
    id: 9, 
    title: "Robotic Project Assembly", 
    category: "projects",
    image: "/3d-print-2.jpeg",
    description: "Student project - Robotic assembly with servo motors"
  },
  { 
    id: 10, 
    title: "Precision 3D Printing", 
    category: "3d-printing",
    image: "/3d-print-3.jpeg",
    description: "Quality measurement of 3D printed components"
  },
  { 
    id: 11, 
    title: "3D Printing Lab", 
    category: "facility",
    image: "/3d-print-4.jpeg",
    description: "Our 3D printing facility with multiple printers"
  },
  { 
    id: 12, 
    title: "Custom Robot Design", 
    category: "projects",
    image: "/3d-print-5.jpeg",
    description: "Complete robot built with 3D printed parts"
  },
  { 
    id: 13, 
    title: "Robotics, AI and 3D Printing Workshop at K.K.Wagh Polytechnic Nashik", 
    category: "workshop",
    image: "/kkwagh-workshop-1.webp",
    description: "Hands-on 3D printing demonstration for students at K.K.Wagh Polytechnic, Nashik"
  },
  { 
    id: 14, 
    title: "Robotics, AI and 3D Printing Workshop at K.K.Wagh Polytechnic Nashik", 
    category: "workshop",
    image: "/kkwagh-workshop-2.webp",
    description: "Interactive AI and Robotics session with students at K.K.Wagh Polytechnic, Nashik"
  },
  { 
    id: 15, 
    title: "Robotics, AI and 3D Printing Workshop at K.K.Wagh Polytechnic Nashik", 
    category: "workshop",
    image: "/kkwagh-workshop-3.webp",
    description: "Workshop session with the enthusiastic batch at K.K.Wagh Polytechnic, Nashik"
  },
  { 
    id: 16, 
    title: "SkyHawk X4 - Custom Built Quadcopter Drone", 
    category: "projects",
    image: "/skyhawk-drone.webp",
    description: "Fully custom-built quadcopter drone with FlySky remote controller - ready for takeoff!"
  },
  { 
    id: 17, 
    title: "Personal Assistance Robot", 
    category: "projects",
    image: "/personal-assistance-robot.webp",
    description: "Friendly personal assistance robot with an expressive smart display face, designed and built at FutureBuildX"
  }
];

export const products = [
  {
    id: 1,
    name: "Fairy Flower Vase - 7 inches Tall",
    price: 350,
    image: "/product-fairy-vase.jpeg",
    description: "Beautifully detailed 3D printed fairy vase with intricate floral design. A perfect decorative piece for your home or office.",
    note: "Multiple height options are available",
    tags: ["3D Printed", "Home Decor", "Customizable"]
  },
  {
    id: 2,
    name: "Hoodie Style Pen Holder",
    price: 200,
    image: "/product-hoodie-pen-holder.jpeg",
    description: "Quirky 3D printed hoodie-shaped pen holder that adds fun and style to your desk. Holds pens, pencils, and markers with ease.",
    note: "Multiple color options are available",
    tags: ["3D Printed", "Desk Accessory", "Customizable"]
  },
  {
    id: 3,
    name: "3D Printed Swans",
    price: 250,
    priceLabel: "₹250 each",
    image: "/product-swans.jpeg",
    description: "Elegant 3D printed swan sculptures with smooth curved design. A graceful decorative pair for your home, office, or as a gift.",
    note: "Price is ₹250 per swan",
    tags: ["3D Printed", "Home Decor", "Gift Item"]
  },
  {
    id: 4,
    name: "Wobble Penguins",
    price: 299,
    image: "/product-wobble-penguins.jpeg",
    description: "Adorable 3D printed wobble penguins that rock back and forth without falling over. A fun desk toy and a delightful gift for kids and adults alike.",
    note: "Multiple color options are available",
    tags: ["3D Printed", "Desk Toy", "Gift Item"]
  }
];

export const studentsByYear = {
  "2026": [
    "Ishwari Shivaji Kadlag",
    "Harshada Gopal Tamboli",
    "Sarthak Somnath Chavan",
    "Gaikwad Srushti Sunny",
    "Sakshi Pramod Sonar",
    "Riya Nimba Nikam",
    "Dhanashree Vinod Kasar",
    "Ayush Vasant Dhurjad",
    "Prathamesh Vilas Dalvi",
    "Pranjal Prashant Shewale",
    "Vaishnavi Sandip Jadhav",
    "Ananya Deepak Avhad",
    "Palak Sharad Sonawane",
    "Devyani Krushnakant Chavan",
    "Rutuja Prashant Vanmali",
    "Vedika Bhausaheb Shinde",
    "Abhijeet Udhav Bahirat",
    "Shaikh Anam Mohammad Ali",
    "Yashika Shomu Issrani",
    "Pushkar Vilas Gaykhe",
    "Dalvi Ishwari Sampat",
    "Vidhi Sandeep Kondekar",
    "Shaikh Rida Iqbal",
    "Niyati Atmaram Darekar",
    "Tanushree Pramod Balavkar",
    "Kajal Nilesh Bhat",
    "Shaikh Ishal Irfan",
    "Aayush Deepak Bharade",
    "Ms. Khan Mahi Mujeeb",
    "Gitanjali Amarsing Rajput",
    "Sai Sudhir Patil",
    "Kartiki Rameshwar Veer",
    "Mugdha Sachin Hingmire",
    "Priya Surywanshi",
    "Gauri Sunil Gaykhe",
    "Shaikh Masira Rahil",
    "Yash Dnyaneshwar Tawade",
    "Utkarsha Govind Pandhare",
    "Siddhesh Rajesh Pardeshi",
    "Shubham Sanjay Nahar",
    "Siddhesh Pravin More",
    "Radhey Gholap",
    "Ali Ahmed Anis Shaikh",
    "Vaibhavi Wable",
    "Akshay Dattu Kapadnis",
    "Manish Jitendra Dhole",
    "Vaishnavi Yogesh Patil",
    "Vaishnavi Santosh Jagdhane",
    "Maheen Fatema Rizwan Shaikh Mulani",
    "Tejal Kamalakar Mohan",
    "Ananya Rajendra Patil",
    "Shree Abhay Shirke",
    "Snehal Aabasaheb Datare",
    "Ishwari Nilesh Sangpal",
    "Anvi Ganesh Nagare",
    "Bhakti Santosh Godge",
    "Akshara Nitin Jadhav",
    "Shweta Chandan Tupe",
    "Ayushi Kiran Gaikwad",
    "Bhavesh Pravin Suryawanshi",
    "Aditya Darbarsing Girase",
    "Samarth Samadhan Suryawanshi",
    "Prathemesh Pawar",
    "Om Kapse"
  ]
};

export const partnerships = [
  {
    id: 1,
    title: "K.K.Wagh Polytechnic, Nashik",
    type: "MoU Signed",
    description: "Signed a 3-year MoU with K.K.Wagh Polytechnic Nashik for collaborative training programs in AI, Robotics, and 3D Printing."
  },
  {
    id: 2,
    title: "Arthtech Automation, Pune",
    type: "Partnership",
    description: "Strategic partnership with Arthtech Automation, Pune to strengthen industry-oriented automation training and projects."
  },
  {
    id: 3,
    title: "FoundeX Community at Ajeenkya DY Patil, Pune",
    type: "Collaboration",
    description: "Collaboration with the FoundeX Community at Ajeenkya DY Patil, Pune to foster innovation and entrepreneurship among students."
  }
];

export const achievements = [
  {
    id: 1,
    title: "Top 100 Startups - MSBTE Bhau Institute Incubation Program 2026",
    description: "FutureBuildX is selected among Top 100 Startups for the MSBTE Bhau Institute Incubation Program 2026 at COEP, Maharashtra."
  }
];

export const contactInfo = {
  email: "futurebuildx.official@gmail.com",
  phone: "+91 97627 17034",
  phone2: "+91 80876 48760",
  address: "Nashik, Maharashtra, India",
  social: {
    linkedin: "https://www.linkedin.com/company/futurebuildxofficial/",
    twitter: "https://twitter.com/futurebuildx",
    instagram: "https://www.instagram.com/futurebuildx?igsh=MWVtajFib293Z3I3cQ==",
    facebook: "https://facebook.com/futurebuildx"
  }
};
